// extracted by mini-css-extract-plugin
module.exports = {"Search":"slider_Search__O_Hse","Citys":"slider_Citys__WPbqW","Title":"slider_Title__pjsJO","Close":"slider_Close__dFU60"};